import React from "react";
import { observer } from "mobx-react-lite";
import { Hooks } from "@xt/xtbase";
import step4Img from "@/assets/img/cfd-guide/guide1.png";
import lineImg from "@/assets/img/cfd-guide/line.png";
import { useCfdGuideStageRect } from "./useCfdGuideStageRect";
import { useCfdGuideAnchoredTipLayout } from "./useCfdGuideAnchoredTipLayout";
import styles from "./ProGuideStep4.module.scss";

const { useTranslation } = Hooks;

export type ProGuideStep4Props = {
  onSkip: () => void;
  onNext: () => void;
};

const DESIGN_WIDTH = 375;

function getScale(): number {
  if (typeof window === "undefined") return 1;
  const w = window.innerWidth || DESIGN_WIDTH;
  return w / DESIGN_WIDTH;
}

const ProGuideStep4: React.FC<ProGuideStep4Props> = ({ onSkip, onNext }) => {
  const t = useTranslation();

  const scale = getScale();
  const anchor = useCfdGuideStageRect('[data-guide-target="proTradeTypeRow"]');
  const tipLayout = useCfdGuideAnchoredTipLayout(anchor, scale);

  const imgSrc = (step4Img as any)?.src || (step4Img as any);
  const lineImgSrc = (lineImg as any)?.src || (lineImg as any);

  return (
    <div style={{ ["--sg-scale" as any]: scale }}>
      {anchor && tipLayout ? (
        <>
          <div
            className={styles.highlightRect}
            style={{
              position: "fixed",
              left: anchor.left,
              top: anchor.top,
              width: anchor.width,
              height: anchor.height,
              zIndex: 10001,
            }}
          >
            <div className={styles.orderTypeSelect}>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <circle cx="7" cy="7" r="6" stroke="rgba(112, 122, 138, 1)" strokeWidth="1" />
                <path d="M7 4V7L9 9" stroke="rgba(112, 122, 138, 1)" strokeWidth="1" strokeLinecap="round" />
              </svg>
              <span className={styles.orderTypeValue}>{t("cfd.marketOrder")}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
                <path d="M10 0H0L5 6L10 0Z" fill="rgba(255, 255, 255, 0.56)" />
              </svg>
            </div>
          </div>

          <div
            className={styles.tip}
            style={{
              position: "fixed",
              left: tipLayout.tipLeft,
              top: anchor.top + anchor.height + tipLayout.gapBelow,
              width: tipLayout.tipWidth,
              zIndex: 10001,
            }}
          >
            <div className={styles.tipBg}>
              <div className={styles.tipText}>
                <div className={styles.tipTitle}>{t("cfd.guide.pro.step4.title")}</div>
                <div className={styles.tipDesc}>{t("cfd.guide.pro.step4.desc")}</div>
              </div>
              <img className={styles.tipImg} src={imgSrc} alt="" />
            </div>
            <div className={styles.star1} />
            <div className={styles.star2} />
            <img
              className={styles.lineImg}
              src={lineImgSrc}
              alt=""
              style={{
                left: tipLayout.lineCenterInTip,
                transform: "translateX(-50%)",
              }}
            />
          </div>
        </>
      ) : null}

      <div className={styles.btnGroup}>
        <button type="button" className={`${styles.btn} ${styles.btnPrimary}`} onClick={onNext}>
          {`${t("cfd.guide.next")} 4/9`}
        </button>
        <button type="button" className={`${styles.btn} ${styles.btnGhost}`} onClick={onSkip}>
          {t("cfd.guide.skip")}
        </button>
      </div>
    </div>
  );
};

export default observer(ProGuideStep4);
